export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "content",
        component: resolve => require(["@/views/content/index.vue"], resolve),
        children: [
          {
            path: "questionnaire/list",
            name: "list",
            component: resolve => require(["@/modules/questionnaire/pages/list.vue"], resolve),
          },
          {
            path: "questionnaire/edit/:id",
            name: "edit",
            component: resolve => require(["@/modules/questionnaire/pages/edit.vue"], resolve),
          },
          {
            path: "questionnaire/report/:id",
            name: "report",
            component: resolve => require(["@/modules/questionnaire/pages/report.vue"], resolve),
          },
        ],
      },
    ],
  }
];
